import React from "react";
import { Reveal } from "./Reveal";
import { BoxIcon } from "lucide-react";
type SectionHeadingProps = {
  kicker: string;
  icon: BoxIcon;
  title: React.ReactNode;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  kicker,
  icon: Icon,
  title,
  lead,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <Reveal className={align === 'center' ? 'mx-auto max-w-3xl text-center' : ''} data-id="element-16" data-mp="blogf546m63k">
      <p className={`mb-3.5 inline-flex items-center gap-2 font-display text-[13px] font-bold uppercase tracking-[0.14em] ${dark ? 'text-tangerine-light' : 'text-tangerine'}`} data-id="element-17" data-mp="giex9unt95q1">
        <Icon className="h-4 w-4" aria-hidden="true" data-id="element-18" data-mp="6tdg415j4iah" />
        {kicker}
      </p>
      <h2 className={`text-[30px] font-extrabold leading-[1.1] md:text-[46px] [&_em]:not-italic ${dark ? 'text-cream [&_em]:text-tangerine-light' : 'text-forest [&_em]:text-tangerine'}`} data-id="element-19" data-mp="uj7uwo9esgxd">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[17px] md:text-[19px] ${dark ? 'text-forest-soft' : 'text-muted'}`} data-id="element-20" data-mp="1t9frx7p8l8jr">
          {lead}
        </p>}
    </Reveal>;
}